import React, {Component} from 'react';
import {Link, NavLink} from 'react-router-dom';
import Sticky from 'react-stickynode';

class CustomNavbar extends Component {
    render() {
        var {mClass, nClass, cClass, hbtnClass} =this.props;
        return (
            <Sticky top={0} innerZ={9999} activeClass="navbar_fixed">
                <header className="header_area">
                <nav className={`navbar navbar-expand-lg menu_one ${mClass}`}>
                    <div className={`container ${cClass}`}>
                        <Link className={`navbar-brasnd`} to="/">
                            <img src={require("../img/logo.png")} alt="logo"/>
                        </Link>
                        <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="menu_toggle">
                                <span className="hamburger">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                                <span className="hamburger-cross">
                                    <span></span>
                                    <span></span>
                                </span>
                            </span>
                        </button>
                        <div style={{width: "15%"}}></div>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className={`navbar-nav menu  ${nClass}`}>
                                <li className="nav-item"><NavLink title="Home" className="nav-link" to="/home">Home</NavLink></li>
                                <li className="nav-item"><NavLink title="Solutions" className="nav-link" to="/solutions">Solutions</NavLink></li>
                                <li className="nav-item"><NavLink title="Resources" className="nav-link" to="/resources">Resources</NavLink></li>
                                <li className="nav-item"><NavLink title="About Us" className="nav-link" to="/aboutus">About Us</NavLink></li>
                                <li className="nav-item"><NavLink title="Contact" className="nav-link" to="/contact">Contact</NavLink></li>
                            </ul>
                            <a className={`btn_get  ${hbtnClass}`} href="https://gimli.hemdahl.com/login">Login</a>
                        </div>
                    </div>
                </nav>
                </header>
            </Sticky>
        );
    }
}

export default CustomNavbar;